const grade = {
  root: "grade",
  root_plural: "grades",
};
export default grade;
